module.exports = "/static/img/drop-alpha.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/screens/Screen3/water/img/drop-alpha.png
// module id = 464
// module chunks = 0